import { Component, forwardRef, Input, OnDestroy, OnInit } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { DateService } from "@root/shared/service/date.service";
import { TranslateService } from "@root/shared/service/translate.service";
import {
  getYear,
  getQuarter,
  startOfYear,
  endOfYear,
  startOfMonth,
  endOfMonth,
  startOfDay,
  endOfDay,
  compareAsc,
  isSameDay,
  addDays,
} from "date-fns";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs";
import { PresetRanges, PresetMonthRanges } from "./preset-ranges";

export const RANGE_PICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RangePickerComponent),
  multi: true,
};
/// 对 nz-range-date-picker 的简单封装
/// 唯一的不同点是input框的不同
/// 使用 nz-range-date-picker + nz-dropdown 来模拟
@Component({
  selector: "host-range-picker",
  templateUrl: "./range-picker.component.html",
  styleUrls: ["./range-picker.component.scss"],
  providers: [RANGE_PICKER_VALUE_ACCESSOR],
})
export class RangePickerComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() placeholder = this.t.t("placeholder.any_time");
  @Input() mode: "date" | "month" | "quarter" | "year" = "date";
  @Input() showFooter = true;
  @Input() size: "small" | "large" | "default" = "default";
  @Input() disabledDate;
  value: Date[];
  dropdownVisible = false;
  _registerOnChange: (value: any) => void = (r: any) => {};
  // readonly presetRanges = PresetRanges;
  textView;
  // get textView () {
  //   if (this.value?.length > 1) {
  //     const [start, end] = this.value;
  //     return `${this.dateSrv.format(start, ['MD'])}~${this.dateSrv.format(end, ['MD'])}`;
  //   }
  // }

  get presetRanges() {
    if (this.mode === "month" || this.mode === "quarter") {
      return PresetMonthRanges;
    } else if (this.mode === "date") {
      return PresetRanges;
    }
  }

  private destory$ = new Subject();

  constructor(
    private dateSrv: DateService,
    private t: TranslateService,
  ) {}

  ngOnInit() {
    this.dateSrv.dateFormatChange$.pipe(takeUntil(this.destory$)).subscribe((rst) => {
      this.updateTextView();
    });
  }
  onDatesChange(value) {
    this.onSelectDates(value);
    this.updateTextView();
  }

  onClickPreset(preset) {
    console.log("on click preset: ", preset);
    const { label, value } = preset;
    this.onSelectDates(value);
    this.updateTextView(this.t.t("component.search." + label));
  }

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(value: Date[] | string): void {
    if (typeof value === "string") {
      const preset = this.presetRanges.find((p) => p.label === value);
      if (preset) {
        this.onClickPreset(preset);
      }
    } else {
      this.value = value;
      this.updateTextView();
    }
  }

  private onSelectDates(_value: Date[]) {
    const value = _value?.sort(compareAsc);
    if (this.mode === "year") {
      this.value = [startOfYear(value[0]), endOfYear(value[1])];
    } else if (this.mode === "month") {
      this.value = [startOfMonth(value[0]), endOfMonth(value[1])];
    } else if (this.mode === "date") {
      this.value = [startOfDay(value[0]), endOfDay(value[1])];
    } else {
      this.value = value;
    }
    console.log("on select dates: ", this.value);
    this._registerOnChange(this.value);

    this.closeDropdownPanel();
  }

  private closeDropdownPanel() {
    this.dropdownVisible = false;
  }

  private updateTextView(text?) {
    if (text) {
      this.textView = text;
    } else if (this.value?.length > 1) {
      // const value = this.value.sort();
      const [start, end] = this.value;

      const preset = this.isMeetsPresetValues(start, end);
      if (preset) {
        this.textView = this.t.t("component.search." + preset.label);
      } else if (isSameDay(start, end)) {
        this.textView = `${this.dateFormatter(start)}`;
      } else {
        this.textView = `${this.dateFormatter(start)} ~ ${this.dateFormatter(end)}`;
      }
    } else {
      this.textView = null;
    }
  }

  private isMeetsPresetValues(start: Date, end: Date) {
    return PresetRanges.find((item) => {
      if (this.mode === "date") {
        return isSameDay(startOfDay(item.value[0]), start) && isSameDay(endOfDay(item.value[1]), end);
      }
    });
  }

  private dateFormatter(date: Date) {
    if (this.mode === "year") {
      return getYear(date);
    } else if (this.mode === "quarter") {
      return getYear(date) + "-Q" + getQuarter(date);
    } else if (this.mode === "month") {
      return this.dateSrv.format(date, ["YM"]);
    } else {
      return this.dateSrv.format(date, ["YMD"]);
    }
  }

  ngOnDestroy(): void {
    this.destory$.next(null);
    this.destory$.complete();
  }
}
